import "./poster-builder.7ec0a949.js";
import "./poster-builder.b2a72de8.js";
import "./poster-builder.6b9408a2.js";
import "./poster-builder.cc8ec761.js";
import "./woordenboek-poster.9018b83c.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2835"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2835"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7vXI8", function(module, exports) {
const $5789bf028b05e78e$var$isMockup = new URLSearchParams(window.location.search).get("mockup") === "true";
document.documentElement.classList.toggle("mockup", $5789bf028b05e78e$var$isMockup);
class $5789bf028b05e78e$var$TegelOptions extends HTMLElement {
    connectedCallback() {
        this.innerHTML = /* html */ `
        <div class="js-toggle-for-material d-none" data-material="tegel">
            <p>
            <strong data-i18n="components.productOptions.chooseSize">Kies je formaat</strong>
            </p>
            <div class="js-poster-size d-flex mb-4">
            <div
                class="js-size-option style-option size p-2 mr-1"
                data-size="small"
                data-price="29.95"
            >
                <strong>13x13 cm</strong>
                <hr class="my-2" />
                <small print-price data-i18n-currency="29.95">\u{20AC}29,95</small>
            </div>
            </div>
        </div>
        <div class="js-toggle-for-material" data-material="tegel">
            <p><strong data-i18n="components.tileOptions.chooseAccessory">Kies een accessoire</strong></p>
            <div class="js-acryl-block mb-4">
                <div class="d-flex mb-3">
                    <div
                        class="js-block-option framed style-option frame-option p-2 mr-1"
                        data-block="black-frame"
                        data-price="14.95"
                    >
                        <img
                        src="https://wallable.nl/wp-content/uploads/builder-images/tegellijst-zwart.webp"
                        class="img-fluid mb-2 mt-0 mx-auto rounded"
                        style="max-height:80px;"
                        />
                        <strong data-i18n="components.tileOptions.blackFrame">Zwarte lijst</strong>
                        <hr class="my-2" />
                        <small class="js-block-price discount-price" data-i18n-currency="14.95">\u{20AC}14,95</small>
                    </div>
                    <div
                        class="js-block-option framed style-option frame-option p-2 mr-1"
                        data-block="oak-frame"
                        data-price="14.95"
                    >
                        <img
                        src="https://wallable.nl/wp-content/uploads/builder-images/tegellijst-eiken.webp"
                        class="img-fluid mb-2 mt-0 mx-auto rounded"
                        style="max-height:80px;"
                        />
                        <strong data-i18n="components.tileOptions.oakFrame">Eiken lijst</strong>
                        <hr class="my-2" />
                        <small class="js-block-price discount-price" data-i18n-currency="14.95">\u{20AC}14,95</small>
                    </div>
                </div>
                <div class="d-flex">
                    <div
                        class="js-block-option framed style-option frame-option p-2 mr-1"
                        data-block="black"
                        data-price="6.95"
                    >
                        <img
                        src="https://wallable.nl/wp-content/uploads/2026/02/tegelhouder-zwart.webp"
                        class="img-fluid mb-2 mt-0 mx-auto rounded"
                        style="max-height:80px;"
                        />
                        <strong data-i18n="components.tileOptions.blackStand">Zwarte houder</strong>
                        <hr class="my-2" />
                        <small class="js-block-price discount-price" data-i18n-currency="6.95">\u{20AC}6,95</small>
                        <span class="badge loved mt-2 mx-auto" data-i18n="components.productOptions.mostPopular">Meest gekozen</span>
                    </div>
                    <div
                        class="js-block-option framed style-option frame-option p-2 mr-1"
                        data-block="oak"
                        data-price="6.95"
                    >
                        <img
                        src="https://wallable.nl/wp-content/uploads/2026/02/tegelhouder-eiken.webp"
                        class="img-fluid mb-2 mt-0 mx-auto rounded"
                        style="max-height:80px;"
                        />
                        <strong data-i18n="components.tileOptions.oakStand">Eiken houder</strong>
                        <hr class="my-2" />
                        <small class="js-block-price discount-price" data-i18n-currency="6.95">\u{20AC}6,95</small>
                    </div>
                </div>
                <div
                    class="js-block-option style-option frame-option mt-3 p-1 mr-1"
                    data-block="no-block"
                    data-price="0"
                >
                    <span data-i18n="components.tileOptions.noAccessory">Zonder accessoire</span>
                </div>
            </div>
        </div>
    `;
    }
}
customElements.define("tegel-options", $5789bf028b05e78e$var$TegelOptions);

});

// Import components
parcelRequire("1enj3");
parcelRequire("eBwC4");
class $856873e5c93ff464$var$FramedPosterOptions extends HTMLElement {
    connectedCallback() {
        this.innerHTML = /* html */ `
        <div class="js-toggle-for-material" data-material="framed-poster">
            <p>
            <strong>Kies je formaat</strong>
            </p>
            <div class="js-poster-size d-flex mb-4">
            <div
                class="js-size-option style-option size p-2 mr-1"
                data-size="small"
                data-price="37.95"
            >
                <strong>S</strong><small>(21x30cm)</small>
                <hr class="my-2" />
                <small>\u{20AC}37,95</small>
            </div>
            <div
                class="js-size-option style-option size p-2 mr-1"
                data-size="medium"
                data-price="49.95"
            >
                <strong>M</strong><small>(30x40cm)</small>
                <hr class="my-2" />
                <small>\u{20AC}49,95</small>
                <span class="badge loved mt-2 mx-auto">Bestseller</span>
            </div>
            <div
                class="js-size-option style-option size p-2 mr-1"
                data-size="large"
                data-price="74.95"
            >
                <strong>L</strong><small>(50x70cm)</small>
                <hr class="my-2" />
                <small>\u{20AC}74,95</small>
            </div>
            </div>
        </div>
        <div class="js-toggle-for-material" data-material="framed-poster">
            <p><strong>Kies je lijst</strong></p>
            <div class="js-poster-frame d-flex mb-3">
            <div
                class="js-frame-option framed style-option frame-option p-2 mr-1"
                data-frame="white"
            >
                <img
                src="https://wallable.nl/wp-content/uploads/2025/05/white-frame.webp"
                width="50px"
                class="mb-2 mx-auto"
                />
                <strong>Witte lijst</strong> (hardhout)
            </div>
            <div
                class="js-frame-option framed style-option frame-option p-2 mr-1"
                data-frame="black"
            >
                <img
                src="https://wallable.nl/wp-content/uploads/2024/02/black-frame.webp"
                width="50px"
                class="mb-2 mx-auto"
                />
                <strong>Zwarte lijst</strong> (hardhout)
                <span class="badge loved mt-2 mx-auto">Bestseller</span>
            </div>
            <div
                class="js-frame-option framed style-option frame-option p-2 mr-1"
                data-frame="oak"
            >
                <img
                src="https://wallable.nl/wp-content/uploads/2024/02/oak-frame.webp"
                width="50px"
                class="mb-2 mx-auto"
                />
                <strong>Naturel lijst</strong> (eiken)
            </div>
            </div>
            <button class="btn btn-danger js-remove-frame w-100 mb-3"><i class="fa-solid fa-trash-alt"></i> Lijst verwijderen</button>
        </div>
    `;
    }
}
customElements.define("framed-poster-options", $856873e5c93ff464$var$FramedPosterOptions);


parcelRequire("ekXg5");
parcelRequire("9hC2G");
parcelRequire("7vXI8");
parcelRequire("3skPo");
parcelRequire("fzSrD");

var $7JB23 = parcelRequire("7JB23");
parcelRequire("3MUFr");

var $6KOho = parcelRequire("6KOho");

var $k4QTz = parcelRequire("k4QTz");

var $fRa1e = parcelRequire("fRa1e");
var $73358f6898d25b9d$exports = {};
$73358f6898d25b9d$exports = JSON.parse('{"words":[{"word":"Mama","pronounce":"[Ma-ma]","wordtype":"Substantiv","description":"Die Frau, die dich geboren hat und dich liebt Egal was, diejenige, die ihr Kind voran stellt sich selbst und auf die Sie sich vor allem verlassen k\xf6nnen. Sie ist geduldig, freundlich, warmherzig, liebt, n\xe4hrt, lehrt, sch\xfctzt, tr\xf6stet, f\xfchrt, unterst\xfctzt, pflegt, umarmt, sch\xe4tzt und beruhigt. Sie ist die Sch\xf6pferin und Bewahrerin kostbarer Erinnerungen. Sie hat den h\xe4rtesten, aber lohnendsten Job der Welt."},{"word":"Papa","pronounce":"[Pa-pa]","wordtype":"Substantiv","description":"Der Mann mit dem Silber im Haar und dem Gold im Herzen. Ein F\xfcrsorger, Held, Vorbild und Besch\xfctzer, der sich oft f\xfcr seine Familie aufopfert. Jemand, der alles schaffen und reparieren kann. Er ist au\xdfen hart und z\xe4h, aber innen weich und f\xfcrsorglich.<br/>Gibt die st\xe4rksten Umarmungen."},{"word":"Lehrerin","pronounce":"[Leh-re-rin]","wordtype":"Substantiv","description":"Jemand, der Kinder unterrichtet. Sie inspiriert und hilft ihnen zu wachsen, sie hat Augen im R\xfccken, ist geduldig und hilft Kindern, die beste Version von sich selbst zu sein. Eine liebe und gute Lehrerin hinterl\xe4sst einen lebenslangen Eindruck in deinem Herzen."},{"word":"Meister","pronounce":"[Meis-ter]","wordtype":"Substantiv","description":"Jemand, der Kinder unterrichtet. Er inspiriert sie und hilft ihnen zu wachsen, er hat Augen im R\xfccken, ist geduldig und hilft Kindern, die beste Version ihrer selbst zu sein. Ein lustiger und guter Meister hinterl\xe4sst einen lebenslangen Eindruck in deinem Herzen."},{"word":"Tante","pronounce":"[Tan-te]","wordtype":"Substantiv","description":"Eine absolute Vertrauensperson und einzigartige Lebensgef\xe4hrtin, auf die man sich immer verlassen kann. Sie bewahrt Geheimnisse wie eine Schwester und teilt die besten Momente wie eine beste Freundin. Mit ihr kannst du Pferde stehlen und all die spannenden Abenteuer erleben, die f\xfcr Mama zu gef\xe4hrlich sind. Genau wie eine Mama, nur cooler und mit weniger Regeln."},{"word":"Onkel","pronounce":"[On-kel]","wordtype":"Substantiv","description":"Einer, der dir hilft, Unfug zu treiben und dich immer zum Lachen bringt, der Berater, Helfer und Besch\xfctzer, eine Quelle grenzenlosen Spa\xdfes und Lachens. Derjenige, der geduldig, gro\xdfz\xfcgig und freundlich ist, ein Mann, der gesch\xe4tzt und geliebt wird."},{"word":"Gro\xdfvater","pronounce":"[Gro\xdf-va-ter]","wordtype":"Substantiv","description":"Der Mann, von dem man alles lernen kann, der in jeder Situation Rat wei\xdf und immer die passende Weisheit parat hat. Er kann alles reparieren, was selbst Papa nicht konnte. Er liebt seine Enkelkinder mehr als alles andere. Er hat die verr\xfccktesten Ideen und ist der gr\xf6\xdfte Spa\xdfvogel. F\xfcr die ganze Familie ist er eine Quelle der Liebe und Geborgenheit."},{"word":"Gro\xdfmutter","pronounce":"[Gro\xdf-mu-ter]","wordtype":"Substantiv","description":"Eine Frau mit einem Herz aus Gold. Sie liebt ihre Enkelkinder \xfcber alles und bewahrt alle ihre Geheimnisse. Sie liebt es, S\xfc\xdfigkeiten zu verteilen, K\xfcsse, Umarmungen und viel Liebe. Sie ist die beste B\xe4ckerin der Welt und l\xe4sst Sie nie ohne einen vollen Bauch nach Hause gehen."},{"word":"Bruder","pronounce":"[Bru-der]","wordtype":"Substantiv","description":"Allererster Spielkamerad und gr\xf6\xdfter Rivale zugleich; der Mensch, auf den immer Verlass ist (sp\xe4testens wenn es hart auf hart kommt); der Freund, dem du bedenkenlos alle Geheimnisse anvertrauen kannst; liebt dich auch, wenn du ihn auf die Palme bringst"},{"word":"Schwester","pronounce":"[Schwes-ter]","wordtype":"Substantiv","description":"Eine Frau, die denselben Vater und/oder dieselbe Mutter hat, eine Besch\xfctzerin, die ein Band teilt, das niemand sonst versteht, eine H\xfcterin von Geheimnissen, die immer bereit ist, durch dick und d\xfcnn zu helfen. Eine beste Freundin f\xfcrs Leben, die mehr geliebt wird, als sie je wissen wird."},{"word":"Tochter","pronounce":"[Toch-ter]","wordtype":"Substantiv","description":"Eines der sch\xf6nsten M\xe4dchen, die diese Welt zu bieten hat. Sie ist ein kleines M\xe4dchen, das zu deinem besten Freund heranw\xe4chst. Jemand, mit dem man lacht, mit dem man tr\xe4umt und den man von ganzem Herzen liebt."},{"word":"Liebe","pronounce":"[Lie-be]","wordtype":"Substantiv","description":"Liebe ist tiefe Akzeptanz und Zuneigung, Wohlwollen oder Hingabe f\xfcr einen anderen oder m\xf6glicherweise f\xfcr sich selbst. Sie kann sich auch auf ein Tier, eine Sache oder einen Gegenstand beziehen. Bei einem Schatz geht es nicht immer um Geld, aber manchmal wird er auch zur Liebe gez\xe4hlt. Einander zu verstehen, ohne ein Wort, das wirklich Liebe ist, das ist es, was dazu geh\xf6rt."},{"word":"Schatz","pronounce":"[Schatz]","wordtype":"Substantiv","description":"Ein Kosename f\xfcr deinen Freund, deine Freundin, eine beste Freundin, jemanden, mit dem du dich gut verstehst. Es ist jemand, mit dem man eine gute Beziehung hat. Ihr versteht euch sehr gut. Darling ist ein Verkleinerungswort f\xfcr Schatz."},{"word":"Sohn","pronounce":"[Sohn]","wordtype":"Substantiv","description":"Ein unbezahlbarer Gewinn f\xfcr die Familie. Und das nicht nur, weil er eines Tages mehr essen kann, als er selbst wiegt. Er zieht es vor, sich mit einer Reihe von unverst\xe4ndlichen Lauten zu verst\xe4ndigen. Aber gleichzeitig bringt er so viel Liebe, Stolz und gute Laune mit, dass man ihm nichts vorwerfen kann."},{"word":"Familie","pronounce":"[Fa-mi-lie]","wordtype":"Substantiv","description":"Menschen, die sich kennen, einander vertrauen und sich immer gegenseitig unterst\xfctzen. Auch wenn Liebe und Chaos hier manchmal dicht beieinander liegen, bleibt es der Ort, an dem das Herz zu Hause ist. Es gibt Wurzeln und Fl\xfcgel und ist f\xfcreinander da, in guten und in schlechten Zeiten, und f\xfcr das Leben."},{"word":"Prost","pronounce":"[Prost]","wordtype":"zwischenruf","description":"Wird ausgesprochen, wenn man mit einem Trinkspruch den Wunsch nach Erl\xf6sung bekr\xe4ftigt, d. h. auf das Wohlergehen von jemandem trinkt, einschlie\xdflich guter Gesundheit. Der Trinkspruch wird dann durch Erheben oder Anklopfen des Glases best\xe4tigt, wobei zun\xe4chst das gef\xfcllte eigene Trinkglas gegen das gef\xfcllte Glas eines anderen geklopft wird. Man nimmt einen Schluck und sagt dabei das Wort \u201EProst\u201C."},{"word":"Pensionado","pronounce":"[Pen-si-o-na-do]","wordtype":"Substantiv","description":"Informeller Name f\xfcr einen Rentner. Vom Ursprung her vor allem zur Bezeichnung eines (oft wohlhabenden) Rentners, der seine Rente f\xfcr einen Teil des Jahres in einem sonnenverw\xf6hnten Land als \xdcberwinterer genie\xdft und dabei die deutsche Rente beh\xe4lt."},{"word":"Freunde","pronounce":"[Freun-de]","wordtype":"adjektiv","description":"Leute kommen zu dir nach Hause, essen dein ganzes Essen, trinken deinen ganzen Wein und bringen dich zum Lachen, bis du dir in die Hose machst."},{"word":"Gro\xdfeltern","pronounce":"[Gro\xdf-el-tern]","wordtype":"Substantiv","description":"Sie sind wie Eltern, nur ohne alle Regeln. Sie haben immer ein offenes Ohr und stehen dir mit guten Ratschl\xe4gen zur Seite. Sie sind heimliche Finanziers und gro\xdfe Geschichtenerz\xe4hler. Von ihnen kann man eine Menge lernen."},{"word":"Beste Freundin","pronounce":"[Bes-te-freun-din]","wordtype":"Substantiv","description":"Ist immer f\xfcr dich da. H\xf6rt dir gerne zu, versteht dich aber auch ohne Worte. Bekommt stets die erste Nachricht bei guten oder schlechten Neuigkeiten. Liebt dich so wie du bist und das ein Leben lang.<br/>(vgl. \'Lieblingsmensch\' oder \'Schwester im Herzen\')"},{"word":"Bester Freund","pronounce":"[Bes-ter-freund]","wordtype":"Substantiv","description":"der Kerl, der ein Leben lang f\xfcr dich da ist; er ist immer ehrlich und w\xe4scht dir den Kopf, wenn du Mist baust, vertuscht es aber sicher vor anderen; dein ewiger Ratgeber und -nehmer; sorgt stets daf\xfcr, dass du sicher Zuhause ankommst.<br/>(s.a. \'Buddy\' oder \'Bro\')"},{"word":"Alkohol","pronounce":"[Al-ko-hol]","wordtype":"Substantiv","description":"beherrscht alle Sprachen; l\xf6st keine Probleme, tut Milch allerdings auch nicht; <br/>(ugs. auch \'Suff\' oder \'Sprit\')"},{"word":"Erzieher","pronounce":"[Er-zie-her]","wordtype":"Substantiv","description":"Ein Mann, der Kinder und Jugendliche betreut; jemand, der sich den ganzen Tag mit den lieben Kleinen besch\xe4ftigt; Geschichtenerz\xe4hler; Tr\xe4nentrockner (s.a. Superheld)"},{"word":"Erzieherin","pronounce":"[Er-zie-he-rin]","wordtype":"Substantiv","description":"eine Frau, die Kinder und Jugendliche betreut; jemand, der sich den ganzen Tag mit den lieben Kleinen besch\xe4ftigt; Geschichtenerz\xe4hlerin; Tr\xe4nentrocknerin (s.a. Superheldin)"},{"word":"Freundschaft","pronounce":"[Freund-schaft]","wordtype":"Substantiv","description":"ist eine Herzensangelegenheit, die auf Vertrauen und Zuneigung beruht; ein Band zwischen zwei Seelen, das weder Raum noch Zeit trennen k\xf6nnen"},{"word":"Heimat","pronounce":"[Freund-schaft]","wordtype":"Substantiv","description":"Gebiet, in dem du aufgewachsen bist oder dich zuhause f\xfchlst; ein Ort, an den du immer wieder gerne zur\xfcckkehrst"},{"word":"Kalorien","pronounce":"[Ka-lo-ri-en]","wordtype":"Substantiv Plural","description":"kleine Wesen, die nachts Kleidung enger n\xe4hen, Spiegel verbiegen und G\xfcrtell\xf6cher nach innen verschieben"},{"word":"Karma","pronounce":"[Kar-ma]","wordtype":"Substantiv","description":"bedeutet, die letzte Rolle Klopapier aufzubrauchen ohne f\xfcr Nachschub zu sorgen und anschlie\xdfend die n\xe4chste Person zu sein, die auf Toilette muss"}]}');


class $b9317ea22c2bf357$export$c019608e5b5bb4cb {
    _schema = {};
    _query = {
        'size': 'posterSize',
        'frame': 'posterFrame',
        'giftwrap': 'posterGiftwrapSelect',
        'wordLabel': 'WordLabel',
        'pronounceLabel': 'PronounceLabel',
        'wordTypeLabel': 'WordTypeLabel',
        'descriptionLabel': 'DescriptionLabel',
        'previousCartItemId': 'previousCartItemId'
    };
    _options = {
        'settingsPanel': 'map',
        'posterSize': 'small',
        'posterFrame': 'black'
    };
    constructor(){
        this._searchParams = new URLSearchParams(window.location.search);
        // Flips the queries key and value
        this._queryMap = Object.assign({}, ...Object.entries(this._query).map(([a, b])=>({
                [b]: a
            })));
    }
    checkEncodeURI(str) {
        return /\%/i.test(str);
    }
    get(key, defaultValue = null, defaultType = null) {
        let type = this._schema[key] || defaultType;
        let value = this._getOption(key) || defaultValue;
        if (!type) return value || defaultValue;
        if (type === 'object' && value) {
            if (this.checkEncodeURI(value)) value = decodeURI(value);
            return JSON.parse(value);
        }
        if (type === 'split' && value) return value.replace('[', '').replace(']', '').split(',');
        if (type === 'bool') {
            if (value === 'true' || value === '1' || value === true) return true;
            if (value === 'false' || value === '0' || value === false) return false;
            return this._options[key];
        }
        return value;
    }
    _getOption(key) {
        let value;
        let altKey = this._queryMap[key];
        // Try GET parameters
        value = this._searchParams.get(key);
        if (value !== null) return value;
        // Try GET parameters with custom name
        value = this._searchParams.get(altKey);
        if (value !== null) return value;
        // Try Local storage
        value = localStorage.getItem(key);
        if (value !== null) return value;
        // Return default value
        return this._options[key] || this._options[altKey];
    }
    _getQuery() {}
    all() {
        return this._options;
    }
}



var $47G0t = parcelRequire("47G0t");

var $6Kc1e = parcelRequire("6Kc1e");

var $gF0Ex = parcelRequire("gF0Ex");

var $1OR0H = parcelRequire("1OR0H");

var $8UUYp = parcelRequire("8UUYp");

var $5t1He = parcelRequire("5t1He");

var $gtTze = parcelRequire("gtTze");

var $28FSP = parcelRequire("28FSP");
let $6e24cb752a769415$var$wordsArchive = (0, (/*@__PURE__*/$parcel$interopDefault($fRa1e)));
let $6e24cb752a769415$var$woocommerceUrl = "https://wallable.nl";
const $6e24cb752a769415$var$apiBase = "";
let $6e24cb752a769415$var$marketContext;
let $6e24cb752a769415$var$t = (key)=>key;
let $6e24cb752a769415$var$formatCurrency = (value)=>`\u{20AC}${Number(value).toFixed(2).replace(".", ",")}`;
let $6e24cb752a769415$var$formatDate = (value)=>String(value);
const $6e24cb752a769415$var$i18nReady = (0, $5t1He.initializeI18n)().then((i18n)=>{
    ({ marketContext: $6e24cb752a769415$var$marketContext, t: $6e24cb752a769415$var$t, formatCurrency: $6e24cb752a769415$var$formatCurrency, formatDate: $6e24cb752a769415$var$formatDate } = i18n);
    $6e24cb752a769415$var$woocommerceUrl = $6e24cb752a769415$var$marketContext.services.woocommerceBaseUrl;
    $6e24cb752a769415$var$wordsArchive = $6e24cb752a769415$var$marketContext.market === "de" ? (0, (/*@__PURE__*/$parcel$interopDefault($73358f6898d25b9d$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($fRa1e)));
    $6e24cb752a769415$var$wordsArchive.words.sort((a, b)=>a.word.localeCompare(b.word, $6e24cb752a769415$var$marketContext.locale));
    $6e24cb752a769415$var$getSavedPoster();
    $6e24cb752a769415$var$toggleProductionEnv();
    $6e24cb752a769415$var$calculatePosterPrice();
    $6e24cb752a769415$var$resizePosterWrapper();
    $6e24cb752a769415$var$toggleClearIcons();
    $6e24cb752a769415$var$loadStoredWords();
    $6e24cb752a769415$var$getWordFromQuery();
    $6e24cb752a769415$var$setPreviewMode();
});
const $6e24cb752a769415$var$options = new (0, $b9317ea22c2bf357$export$c019608e5b5bb4cb)();
let $6e24cb752a769415$var$PosterPreviewImage, $6e24cb752a769415$var$WordsModal, $6e24cb752a769415$var$wordQueryParam;
let $6e24cb752a769415$var$ShowMobileSettingPanel = false;
let $6e24cb752a769415$var$PrintTypeSelected = true;
const $6e24cb752a769415$var$BuilderName = $6KOho("body").attr("id");
let $6e24cb752a769415$var$SettingsPanel = $6e24cb752a769415$var$options.get("settingsPanel", "map");
let $6e24cb752a769415$var$PosterSize = $6e24cb752a769415$var$options.get("posterSize", "small");
let $6e24cb752a769415$var$PosterFrame = $6e24cb752a769415$var$options.get("posterFrame", "black");
let $6e24cb752a769415$var$PrintType = $6e24cb752a769415$var$options.get("printType", "paper");
let $6e24cb752a769415$var$AluminiumColor = $6e24cb752a769415$var$options.get("aluminiumColor", "silver");
let $6e24cb752a769415$var$AcrylBlock = $6e24cb752a769415$var$options.get("acrylBlock", "no-block");
let $6e24cb752a769415$var$GiftCardText = "";
let $6e24cb752a769415$var$defaultWordFontSize = 10;
const $6e24cb752a769415$var$WordInput = $6KOho("#word-input");
const $6e24cb752a769415$var$WordLabel = $6KOho(".labels .word");
const $6e24cb752a769415$var$PronounceInput = $6KOho("#pronounce-input");
const $6e24cb752a769415$var$PronounceLabel = $6KOho(".labels .pronounce");
const $6e24cb752a769415$var$WordTypeInput = $6KOho("#word-type-input");
const $6e24cb752a769415$var$WordTypeLabel = $6KOho(".labels .word-type");
const $6e24cb752a769415$var$DescriptionInput = $6KOho("#description-input");
const $6e24cb752a769415$var$DescriptionLabel = $6KOho(".labels .description");
const $6e24cb752a769415$var$PosterWrapper = $6KOho(".map-wrapper");
const $6e24cb752a769415$var$PosterSizeSelect = $6KOho(".js-poster-size");
const $6e24cb752a769415$var$PosterFrameSelect = $6KOho(".js-poster-frame");
const $6e24cb752a769415$var$PosterGiftwrapSelect = $6KOho(".js-giftwrap");
const $6e24cb752a769415$var$GiftCardSelect = $6KOho(".js-giftcard");
const $6e24cb752a769415$var$wordsList = $6KOho(".js-words");
const $6e24cb752a769415$var$AcrylBlockSelect = $6KOho(".js-acryl-block");
const $6e24cb752a769415$var$PrintTypeSelect = $6KOho(".js-print-type");
const $6e24cb752a769415$var$PrintStandSelect = $6KOho(".js-acryl-block");
const $6e24cb752a769415$var$PrintStandUI = $6KOho(".acryl-block");
const $6e24cb752a769415$var$PosterFrameUI = $6KOho(".poster-frame");
const $6e24cb752a769415$var$MapWrapper = $6KOho(".map-wrapper");
const $6e24cb752a769415$var$debugReporter = (0, $1OR0H.DebugReporter)({
    ajaxUrl: $6e24cb752a769415$var$apiBase + "/wp-json/wallable/v1/client-diagnostics",
    containerSelector: ".js-notifications",
    shouldShow: ({ meta: meta })=>meta?.action === "add-to-cart" || meta?.action === "add-poster-order",
    extraContext: ()=>({
            builder: $6KOho("body").attr("id")
        })
}).init();
// For dismissing panel if previewing from shopping cart
function $6e24cb752a769415$var$setPreviewMode() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("preview")) $6e24cb752a769415$var$dismissSettingsPanel();
}
$6KOho(document).ready(function() {
    window.status = "mapbox-ready";
    setTimeout(()=>{
        $6KOho(".anim-wrapper").removeClass("hidden");
        $6KOho(".loading-wrapper").remove();
        $6e24cb752a769415$var$scaleFontSize();
    }, 500);
});
// Input listeners
$6KOho("input.form-control, textarea.form-control").on("input", function() {
    const posterLabel = this.dataset.posterLabel;
    if (!posterLabel || posterLabel === "search-list") return;
    const inputValue = $6KOho(this).val();
    $6KOho(".labels ." + posterLabel).html(inputValue);
    if (posterLabel === "word") $6e24cb752a769415$var$scaleFontSize();
    $6KOho('.js-clear-input[data-field-id="' + posterLabel + '"]').toggle(inputValue !== "");
});
$6KOho(".js-history-back").on("click", function() {
    history.back();
});
// Clear input fields
$6KOho(".js-clear-input").on("click", function() {
    const field = $6KOho(this).data("field-id");
    if (field === "search-list") {
        $6KOho('input.form-control[data-poster-label="search-list"]').val("").trigger("input").trigger("focus");
        $6e24cb752a769415$var$loadStoredWords();
        return;
    }
    $6KOho('input.form-control[data-poster-label="' + field + '"], ' + 'textarea.form-control[data-poster-label="' + field + '"]').val("").trigger("input").trigger("focus");
});
// Check if field has value and show clear icon
function $6e24cb752a769415$var$toggleClearIcons() {
    const inputFields = $6KOho("input.form-control");
    const textAreas = $6KOho("textarea.form-control");
    inputFields.each(function() {
        const inputValue = $6KOho(this).val();
        if (inputValue.trim() === "") {
            let emptyField = $6KOho(this).data("poster-label");
            $6KOho('.js-clear-input[data-field-id="' + emptyField + '"]').hide();
        }
    });
    textAreas.each(function() {
        const inputValue = $6KOho(this).val();
        if (inputValue.trim() === "") {
            let emptyField = $6KOho(this).data("poster-label");
            $6KOho('.js-clear-input[data-field-id="' + emptyField + '"]').hide();
        }
    });
}
function $6e24cb752a769415$var$scaleFontSize() {
    const text = $6KOho(".js-poster-word");
    const textWrapper = $6KOho(".word-wrapper");
    // Reset font size to the default value
    text.css("font-size", $6e24cb752a769415$var$defaultWordFontSize + "em");
    // Calculate the current text width
    const textWidth = text[0].scrollWidth;
    // Calculate the container width
    const containerWidth = textWrapper.width();
    // If the text width exceeds the container width, shrink the font size
    if (textWidth > containerWidth) {
        const newFontSize = $6e24cb752a769415$var$defaultWordFontSize * (containerWidth / textWidth);
        text.css("font-size", newFontSize + "em");
    }
}
// Change print type
$6KOho(document).on("click", ".js-print-option", function() {
    let SelectedPrintType = $6KOho(this).attr("data-print");
    if ($6e24cb752a769415$var$PrintType !== SelectedPrintType) {
        $6e24cb752a769415$var$PrintType = SelectedPrintType;
        $6e24cb752a769415$var$setPrintType($6e24cb752a769415$var$PrintType);
    }
    if ($6KOho(this).hasClass("d-block")) $6e24cb752a769415$var$PrintTypeSelected = true;
    $6e24cb752a769415$var$togglePrintTypes();
});
$6KOho(document).on("click", ".js-show-print-types", function() {
    $6e24cb752a769415$var$togglePrintTypes();
});
function $6e24cb752a769415$var$setPrintType(PrintType) {
    var selectedPrint = $6KOho('.js-print-option[data-print="' + PrintType + '"]');
    $6KOho(".js-print-option").removeClass("active");
    $6KOho(".block-wrapper, body").removeClass("tegel");
    selectedPrint.addClass("active");
    // If acryl
    if (PrintType == "acryl") {
        if ($6e24cb752a769415$var$PosterSize === "large" || $6e24cb752a769415$var$PosterSize === "extra-large") $6e24cb752a769415$var$PosterSize = "small";
        $6e24cb752a769415$var$PosterFrame = "no-frame";
    // If aluminium
    } else if (PrintType == "aluminium") {
        if ($6e24cb752a769415$var$PosterSize === "large" || $6e24cb752a769415$var$PosterSize === "extra-large") $6e24cb752a769415$var$PosterSize = "medium";
        $6e24cb752a769415$var$PosterFrame = "no-frame";
        $6e24cb752a769415$var$setAluminiumColor($6e24cb752a769415$var$AluminiumColor);
    // If Tegel
    } else if (PrintType == "tegel") {
        $6e24cb752a769415$var$PosterSize = "small";
        $6KOho(".block-wrapper, body").addClass("tegel");
        $6e24cb752a769415$var$PosterFrame = "no-frame";
    // If paper
    } else {
        if ($6e24cb752a769415$var$PosterSize === "xs") $6e24cb752a769415$var$PosterSize = "small";
        else if ($6e24cb752a769415$var$PosterSize === "extra-large") $6e24cb752a769415$var$PosterSize = "large";
        $6e24cb752a769415$var$AcrylBlock = "no-block";
    }
    $6e24cb752a769415$var$setStandSelection($6e24cb752a769415$var$AcrylBlock);
    $6e24cb752a769415$var$setFrameSelection($6e24cb752a769415$var$PosterFrame);
    $6e24cb752a769415$var$setPosterFrame($6e24cb752a769415$var$PosterFrame);
    $6e24cb752a769415$var$setPosterSize($6e24cb752a769415$var$PosterSize);
    $6e24cb752a769415$var$setSizeSelection($6e24cb752a769415$var$PosterSize);
    $6e24cb752a769415$var$setPrintStand($6e24cb752a769415$var$AcrylBlock);
    $6e24cb752a769415$var$calculatePosterPrice();
}
function $6e24cb752a769415$var$togglePrintTypes() {
    if ($6e24cb752a769415$var$PrintTypeSelected) {
        $6KOho(".js-print-option").hide();
        $6KOho(".js-toggle-for-material").hide();
        $6KOho(".js-show-print-types").show();
        $6KOho(".js-toggle-for-material[data-material='" + $6e24cb752a769415$var$PrintType + "']").show();
        $6KOho(".js-print-option[data-print='" + $6e24cb752a769415$var$PrintType + "']").show();
        $6e24cb752a769415$var$PrintTypeSelected = false;
    } else {
        $6KOho(".js-print-option").show();
        $6KOho(".js-show-print-types").hide();
        $6KOho(".js-toggle-for-material").hide();
        $6e24cb752a769415$var$PrintTypeSelected = true;
    }
}
// Changing poster
function $6e24cb752a769415$var$setPosterSize(posterSize) {
    $6e24cb752a769415$var$PosterWrapper.removeClass().addClass("map-wrapper size-" + posterSize + " " + $6e24cb752a769415$var$PrintType);
}
// Change poster size
$6KOho(".js-size-option").on("click", function() {
    $6e24cb752a769415$var$PosterSize = $6KOho(this).attr("data-size");
    $6e24cb752a769415$var$setPosterSize($6e24cb752a769415$var$PosterSize);
    $6e24cb752a769415$var$setSizeSelection($6e24cb752a769415$var$PosterSize);
    $6e24cb752a769415$var$calculatePosterPrice();
});
function $6e24cb752a769415$var$setSizeSelection(posterSize) {
    let selectedSize = $6KOho('.js-toggle-for-material[data-material="' + $6e24cb752a769415$var$PrintType + '"] .js-size-option[data-size="' + posterSize + '"]');
    $6KOho(".js-size-option").removeClass("active");
    selectedSize.addClass("active");
    if ($6e24cb752a769415$var$PrintType !== "paper") return;
    let framePrice = 0;
    let frameNormalPrice = 0;
    switch(posterSize){
        case "small":
            framePrice = 15;
            frameNormalPrice = 21.95;
            break;
        case "medium":
            framePrice = 20;
            frameNormalPrice = 24.95;
            break;
        case "large":
            framePrice = 35;
            frameNormalPrice = 39.95;
            break;
        default:
            framePrice = 0;
            frameNormalPrice = 0;
    }
    // If extra-large, force no frame
    if (posterSize === "extra-large") {
        $6e24cb752a769415$var$PosterFrame = "no-frame";
        $6e24cb752a769415$var$setFrameSelection($6e24cb752a769415$var$PosterFrame);
        $6e24cb752a769415$var$setPosterFrame($6e24cb752a769415$var$PosterFrame);
        $6KOho(".js-frame-option").addClass("disabled");
        $6KOho('.js-frame-option[data-frame="no-frame"]').removeClass("disabled");
        $6KOho("small[frame-normal-price]").text("-");
        $6KOho("small[frame-price]").hide();
    } else {
        $6KOho(".js-frame-option").removeClass("disabled");
        $6KOho("small[frame-price]").show();
        $6KOho("small[frame-price]").text($6e24cb752a769415$var$formatCurrency(framePrice));
        $6KOho("small[frame-normal-price]").text($6e24cb752a769415$var$formatCurrency(frameNormalPrice));
        $6KOho(".js-frame-option").not('[data-frame="no-frame"]').attr("data-price", framePrice.toFixed(2));
    }
}
// Change aluminium color
$6KOho(document).on("click", ".js-color-option", function() {
    $6e24cb752a769415$var$AluminiumColor = $6KOho(this).attr("data-color");
    $6e24cb752a769415$var$setAluminiumColor($6e24cb752a769415$var$AluminiumColor);
    $6e24cb752a769415$var$setAluminiumColorSelection($6e24cb752a769415$var$AluminiumColor);
});
function $6e24cb752a769415$var$setAluminiumColor(color) {
    $6e24cb752a769415$var$MapWrapper.attr("data-aluminium-color", color);
}
function $6e24cb752a769415$var$setAluminiumColorSelection(color) {
    var selectedColor = $6KOho('.js-color-option[data-color="' + color + '"]');
    $6KOho(".js-color-option").removeClass("active");
    selectedColor.addClass("active");
}
// Change acryl block
$6KOho(document).on("click", ".js-block-option", function() {
    $6e24cb752a769415$var$AcrylBlock = $6KOho(this).attr("data-block");
    $6e24cb752a769415$var$setStandSelection($6e24cb752a769415$var$AcrylBlock);
    $6e24cb752a769415$var$setPrintStand($6e24cb752a769415$var$AcrylBlock);
    $6e24cb752a769415$var$calculatePosterPrice();
});
function $6e24cb752a769415$var$setStandSelection(AcrylBlock) {
    var selectedBlock = $6KOho('.js-block-option[data-block="' + AcrylBlock + '"]');
    $6KOho(".js-block-option").removeClass("active");
    selectedBlock.addClass("active");
}
function $6e24cb752a769415$var$setPrintStand(AcrylBlock) {
    const isBlackBlock = AcrylBlock === "black";
    const isOakBlock = AcrylBlock === "oak";
    const hasBlock = isBlackBlock || isOakBlock;
    const isBlackFrame = AcrylBlock === "black-frame";
    const isOakFrame = AcrylBlock === "oak-frame";
    const hasFrame = isBlackFrame || isOakFrame;
    $6e24cb752a769415$var$MapWrapper.attr("data-perspective", hasBlock);
    if (hasFrame) {
        $6e24cb752a769415$var$PrintStandUI.addClass("d-none");
        $6e24cb752a769415$var$PosterFrameUI.removeClass("d-none");
        if (isBlackFrame) $6e24cb752a769415$var$setPosterFrame("tile black");
        else if (isOakFrame) $6e24cb752a769415$var$setPosterFrame("tile oak");
    } else if (hasBlock) {
        $6e24cb752a769415$var$PrintStandUI.removeClass("black oak d-none");
        $6e24cb752a769415$var$PosterFrameUI.addClass("d-none");
        if (isBlackBlock) $6e24cb752a769415$var$PrintStandUI.addClass("black");
        else if (isOakBlock) $6e24cb752a769415$var$PrintStandUI.addClass("oak");
        else $6e24cb752a769415$var$PrintStandUI.addClass("d-none");
        $6e24cb752a769415$var$PrintStandUI.toggleClass("hide-shadow", $6e24cb752a769415$var$PrintType === "tegel");
    } else {
        if ($6e24cb752a769415$var$PrintType !== "paper") $6e24cb752a769415$var$PosterFrameUI.addClass("d-none");
        $6e24cb752a769415$var$PrintStandUI.addClass("d-none");
    }
}
// Change poster frame
$6KOho(".js-frame-option").on("click", function() {
    $6e24cb752a769415$var$PosterFrame = $6KOho(this).attr("data-frame");
    $6e24cb752a769415$var$setFrameSelection($6e24cb752a769415$var$PosterFrame);
    $6e24cb752a769415$var$setPosterFrame($6e24cb752a769415$var$PosterFrame);
    $6e24cb752a769415$var$activateGiftwrap($6e24cb752a769415$var$PosterFrame);
    $6e24cb752a769415$var$calculatePosterPrice();
});
function $6e24cb752a769415$var$setPosterFrame(PosterFrame) {
    const frameClasses = [
        "black-frame",
        "oak-frame",
        "white-frame",
        "tile black-frame",
        "tile oak-frame"
    ];
    $6e24cb752a769415$var$PosterFrameUI.removeClass(frameClasses.join(" ") + " d-none");
    if (frameClasses.includes(PosterFrame + "-frame")) $6e24cb752a769415$var$PosterFrameUI.addClass(PosterFrame + "-frame");
    else $6e24cb752a769415$var$PosterFrameUI.addClass("d-none");
    $6e24cb752a769415$var$activateGiftwrap();
}
function $6e24cb752a769415$var$setFrameSelection(frame) {
    var selectedFrame = $6KOho('.js-frame-option[data-frame="' + frame + '"]');
    $6KOho(".js-frame-option").removeClass("active");
    selectedFrame.addClass("active");
}
// Toggle giftwrap
$6KOho(".js-giftwrap").on("change", function() {
    $6e24cb752a769415$var$calculatePosterPrice();
});
function $6e24cb752a769415$var$activateGiftwrap() {
    if ($6e24cb752a769415$var$PrintType === "paper" && $6e24cb752a769415$var$PosterFrame === "no-frame") {
        $6e24cb752a769415$var$PosterGiftwrapSelect.val("false");
        $6KOho(".js-giftwrap option[value=true]").attr("disabled", "disabled").siblings().removeAttr("disabled");
    } else $6KOho(".js-giftwrap option[value=true]").removeAttr("disabled");
}
// Change giftcard text
$6KOho(".js-giftcard").on("change", function() {
    if ($6KOho(this).val() === "true") {
        $6KOho(".js-giftcard-text").show();
        $6e24cb752a769415$var$GiftCardText = $6KOho(".js-giftcard-text").val();
    } else {
        $6KOho(".js-giftcard-text").hide();
        $6e24cb752a769415$var$GiftCardText = "";
    }
    $6e24cb752a769415$var$calculatePosterPrice();
});
$6KOho(".js-giftcard-text").on("change", function() {
    $6e24cb752a769415$var$GiftCardText = $6KOho(this).val();
});
// Calculate poster price
function $6e24cb752a769415$var$calculatePosterPrice() {
    const getPrice = (selector)=>parseFloat($6KOho(selector).find(".active, :selected").attr("data-price")) || 0;
    // Scope material-specific selectors to only the visible material
    const activeMaterialDiv = `.js-toggle-for-material[data-material="${$6e24cb752a769415$var$PrintType}"]`;
    const subtotalPrice = getPrice(`${activeMaterialDiv} .js-poster-size`) + getPrice(`${activeMaterialDiv} .js-acryl-block`) + getPrice($6e24cb752a769415$var$PosterFrameSelect) + getPrice($6e24cb752a769415$var$PosterGiftwrapSelect) + getPrice($6e24cb752a769415$var$GiftCardSelect);
    $6KOho(".subtotal").html($6e24cb752a769415$var$formatCurrency(subtotalPrice));
}
// Create poster preview image
function $6e24cb752a769415$var$createPosterPreview() {
    $6KOho(".poster-frame, .block-wrapper").addClass("hidden");
    $6KOho(".map-wrapper").addClass("shadow-none");
    const element = document.querySelector(".poster-wrapper");
    (0, (/*@__PURE__*/$parcel$interopDefault($7JB23)))(element, {
        scale: window.devicePixelRatio || 2,
        useCORS: true,
        backgroundColor: "#ffffff"
    }).then((canvas)=>{
        $6e24cb752a769415$var$PosterPreviewImage = canvas.toDataURL("image/jpeg", 0.8);
        $6KOho(".js-poster-preview").attr("src", $6e24cb752a769415$var$PosterPreviewImage);
    });
    $6KOho(".map-wrapper").removeClass("shadow-none");
    $6KOho(".poster-frame, .block-wrapper").removeClass("hidden");
}
// Get list of stored words
function $6e24cb752a769415$var$loadStoredWords() {
    $6e24cb752a769415$var$wordsList.html("");
    $6e24cb752a769415$var$wordsArchive.words.forEach((word)=>{
        $6e24cb752a769415$var$wordsList.append(`<a href="#" class="list-group-item list-group-item-action" data-word="${word.word}">${word.word}</a>`);
    });
    $6e24cb752a769415$var$initWordsList();
}
function $6e24cb752a769415$var$initWordsList() {
    $6KOho(".list-group-item").on("click", function() {
        $6e24cb752a769415$var$loadStoredWord($6KOho(this).data("word"));
        $6e24cb752a769415$var$WordsModal.hide();
        setTimeout(()=>{
            $6e24cb752a769415$var$dismissSettingsPanel();
            $6e24cb752a769415$var$scaleFontSize();
        }, 500);
    });
}
function $6e24cb752a769415$var$loadStoredWord(word) {
    const selectedWord = $6e24cb752a769415$var$wordsArchive.words.find((item)=>item.word === word);
    if (selectedWord) // Set text labels
    setTimeout(()=>{
        $6e24cb752a769415$var$WordLabel.html(selectedWord.word);
        $6e24cb752a769415$var$WordInput.val(selectedWord.word);
        $6e24cb752a769415$var$PronounceLabel.html(selectedWord.pronounce);
        $6e24cb752a769415$var$PronounceInput.val(selectedWord.pronounce);
        $6e24cb752a769415$var$WordTypeLabel.html(selectedWord.wordtype);
        $6e24cb752a769415$var$WordTypeInput.val(selectedWord.wordtype);
        $6e24cb752a769415$var$DescriptionLabel.html(selectedWord.description);
        $6e24cb752a769415$var$DescriptionInput.val(selectedWord.description);
    }, 500);
}
// For searching the words list
$6KOho("input.js-search-word").on("input", function() {
    const inputVal = $6KOho(this).val();
    const match = $6e24cb752a769415$var$searchWords(inputVal);
    $6e24cb752a769415$var$wordsList.html("");
    if (match.length !== 0) {
        match.forEach((word)=>{
            $6e24cb752a769415$var$wordsList.append(`<a href="#" class="list-group-item list-group-item-action" data-word="${word.word}">${word.word}</a>`);
        });
        $6e24cb752a769415$var$initWordsList();
    } else $6e24cb752a769415$var$wordsList.append(`<p class="text-center">${$6e24cb752a769415$var$t("dictionary.archive.noResults")}</p>`);
    $6KOho('.js-clear-input[data-field-id="search-list"]').toggle(inputVal !== "");
});
function $6e24cb752a769415$var$searchWords(query) {
    // Convert the query to lowercase for case-insensitive search
    query = query.toLowerCase();
    // Filter the words array to find matching items
    const matchingWords = $6e24cb752a769415$var$wordsArchive.words.filter((word)=>{
        return word.word.toLowerCase().includes(query);
    });
    return matchingWords;
}
// For getting predefined word from url var
function $6e24cb752a769415$var$getWordFromQuery() {
    const regex = new RegExp("[\\?&]word=([^&#]*)");
    const results = regex.exec(window.location.search);
    $6e24cb752a769415$var$wordQueryParam = results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    $6e24cb752a769415$var$wordQueryParam = $6e24cb752a769415$var$wordQueryParam.charAt(0).toUpperCase() + $6e24cb752a769415$var$wordQueryParam.slice(1);
    if ($6e24cb752a769415$var$wordQueryParam !== null && $6e24cb752a769415$var$wordQueryParam !== "") {
        $6e24cb752a769415$var$loadStoredWord($6e24cb752a769415$var$wordQueryParam);
        $6e24cb752a769415$var$dismissSettingsPanel();
    }
}
// For hiding some unnecessary fields on staging
function $6e24cb752a769415$var$toggleProductionEnv() {}
// For removing default values from poster
function $6e24cb752a769415$var$sanitizePosterInput(value) {
    if (value === undefined || value === null || value === "undefined") return "";
    value = String(value);
    var defaultValues = [
        $6e24cb752a769415$var$t("dictionary.editor.defaultWord"),
        $6e24cb752a769415$var$t("dictionary.editor.defaultPronunciation"),
        $6e24cb752a769415$var$t("dictionary.editor.defaultType"),
        $6e24cb752a769415$var$t("dictionary.editor.defaultDescription"),
        "Jouw woord",
        "[Uitspraak]",
        "Woordtype",
        "Definitie van jouw woord...",
        "Ihr Wort",
        "[Aussprache]",
        "Wortart",
        "Definition Ihres Wortes..."
    ];
    var isMatch = false;
    for(var i = 0; i < defaultValues.length; i++)if (defaultValues[i] === value) {
        isMatch = true;
        break;
    }
    if (isMatch) return "";
    else return value;
}
// For saving design to local storage
function $6e24cb752a769415$var$saveDesign() {
    localStorage.setItem("posterSize", $6e24cb752a769415$var$PosterSize);
    localStorage.setItem("posterFrame", $6e24cb752a769415$var$PosterFrame);
    localStorage.setItem("WordLabel", $6e24cb752a769415$var$WordLabel.html());
    localStorage.setItem("PronounceLabel", $6e24cb752a769415$var$PronounceLabel.html());
    localStorage.setItem("WordTypeLabel", $6e24cb752a769415$var$WordTypeLabel.html());
    localStorage.setItem("DescriptionLabel", $6e24cb752a769415$var$DescriptionLabel.html());
    localStorage.setItem("printType", $6e24cb752a769415$var$PrintType);
    localStorage.setItem("acrylBlock", $6e24cb752a769415$var$AcrylBlock);
    localStorage.setItem("aluminiumColor", $6e24cb752a769415$var$AluminiumColor);
}
// For getting design from local storage or parameters
function $6e24cb752a769415$var$getSavedPoster() {
    // Prepare text labels
    if ($6e24cb752a769415$var$BuilderName !== "PrintApp") {
        $6e24cb752a769415$var$WordsModal = new $k4QTz.Modal(document.getElementById("words-modal"));
        if ($6e24cb752a769415$var$options.get("WordLabel") !== null) var wordLabel = $6e24cb752a769415$var$options.get("WordLabel");
        else var wordLabel = $6e24cb752a769415$var$t("dictionary.editor.defaultWord");
        if ($6e24cb752a769415$var$options.get("PronounceLabel") !== null) var pronounceLabel = $6e24cb752a769415$var$options.get("PronounceLabel");
        else var pronounceLabel = $6e24cb752a769415$var$t("dictionary.editor.defaultPronunciation");
        if ($6e24cb752a769415$var$options.get("WordTypeLabel") !== null) var wordTypeLabel = $6e24cb752a769415$var$options.get("WordTypeLabel");
        else var wordTypeLabel = $6e24cb752a769415$var$t("dictionary.editor.defaultType");
        if ($6e24cb752a769415$var$options.get("DescriptionLabel") !== null) var descriptionLabel = $6e24cb752a769415$var$options.get("DescriptionLabel");
        else var descriptionLabel = $6e24cb752a769415$var$t("dictionary.editor.defaultDescription");
    } else {
        var wordLabel = $6e24cb752a769415$var$options.get("WordLabel");
        var pronounceLabel = $6e24cb752a769415$var$options.get("PronounceLabel");
        var wordTypeLabel = $6e24cb752a769415$var$options.get("WordTypeLabel");
        var descriptionLabel = $6e24cb752a769415$var$options.get("DescriptionLabel");
    }
    // Set text labels
    if (!$6e24cb752a769415$var$wordQueryParam) {
        $6e24cb752a769415$var$WordLabel.html(wordLabel);
        $6e24cb752a769415$var$WordInput.val(wordLabel);
        $6e24cb752a769415$var$PronounceLabel.html(pronounceLabel);
        $6e24cb752a769415$var$PronounceInput.val(pronounceLabel);
        $6e24cb752a769415$var$WordTypeLabel.html(wordTypeLabel);
        $6e24cb752a769415$var$WordTypeInput.val(wordTypeLabel);
        $6e24cb752a769415$var$DescriptionLabel.html(descriptionLabel);
        $6e24cb752a769415$var$DescriptionInput.val(descriptionLabel);
    }
    if ($6e24cb752a769415$var$PrintType !== "acryl" && $6e24cb752a769415$var$PrintType !== "aluminium") {
        if ($6e24cb752a769415$var$PosterSize === "xs") $6e24cb752a769415$var$PosterSize = "small";
        if ($6e24cb752a769415$var$PrintType === "framed-poster") $6e24cb752a769415$var$PrintType = "paper";
    }
    if ($6e24cb752a769415$var$BuilderName !== "PrintApp") {
        $6e24cb752a769415$var$setStandSelection($6e24cb752a769415$var$AcrylBlock);
        $6e24cb752a769415$var$setPrintStand($6e24cb752a769415$var$AcrylBlock);
    }
    $6e24cb752a769415$var$PosterSizeSelect.val($6e24cb752a769415$var$PosterSize);
    $6e24cb752a769415$var$setPosterSize($6e24cb752a769415$var$PosterSize);
    $6e24cb752a769415$var$PrintTypeSelect.val($6e24cb752a769415$var$PrintType);
    $6e24cb752a769415$var$setPrintType($6e24cb752a769415$var$PrintType);
    $6e24cb752a769415$var$togglePrintTypes();
    $6e24cb752a769415$var$setAluminiumColorSelection($6e24cb752a769415$var$AluminiumColor);
    $6e24cb752a769415$var$activateGiftwrap();
}
// Resize canvas
$6KOho(window).resize(function() {
    $6e24cb752a769415$var$resizePosterWrapper();
});
function $6e24cb752a769415$var$resizePosterWrapper() {
    (0, $6Kc1e.resizePosterPreview)();
}
window.visualViewport?.addEventListener("resize", $6e24cb752a769415$var$resizePosterWrapper);
// Toggle settings panels
$6KOho(".js-settings-toggle").on("click", function() {
    var target = $6KOho(this).attr("data-target");
    $6KOho(".nav-link").removeClass("active");
    $6KOho(".nav-link[data-target=" + target + "]").addClass("active");
    if (target == "text" && $6e24cb752a769415$var$SettingsPanel !== "text") {
        $6KOho(".settings-panel").addClass("d-none");
        $6KOho(".settings-panel.text").removeClass("d-none");
        $6e24cb752a769415$var$SettingsPanel = "text";
    } else if (target == "size" && $6e24cb752a769415$var$SettingsPanel !== "size") {
        $6KOho(".settings-panel").addClass("d-none");
        $6KOho(".settings-panel.size").removeClass("d-none");
        $6e24cb752a769415$var$SettingsPanel = "size";
    } else if (target == "shop" && $6e24cb752a769415$var$SettingsPanel !== "shop") {
        $6e24cb752a769415$var$setPosterSummary();
        $6KOho(".settings-panel").addClass("d-none");
        $6KOho(".settings-panel.shop").removeClass("d-none");
        $6KOho(".nav-pills .nav-link").removeClass("active");
        $6KOho("#pills-shop-tab").addClass("active");
        $6e24cb752a769415$var$SettingsPanel = "shop";
    }
    if ($6e24cb752a769415$var$ShowMobileSettingPanel == false) {
        $6KOho(".side-nav").addClass("shown");
        $6e24cb752a769415$var$ShowMobileSettingPanel = true;
    }
    $6KOho(".options-container").scrollTop(0);
    $6e24cb752a769415$var$saveDesign();
});
$6KOho(".js-close-settings").on("click", function() {
    $6e24cb752a769415$var$dismissSettingsPanel();
});
function $6e24cb752a769415$var$dismissSettingsPanel() {
    $6KOho(".side-nav").removeClass("shown");
    $6e24cb752a769415$var$ShowMobileSettingPanel = false;
}
function $6e24cb752a769415$var$isPrintApp() {
    return $6KOho("html").hasClass("PrintApp");
}
// Prepping shopping cart
function $6e24cb752a769415$var$setPosterSummary() {
    (0, $gF0Ex.getShoppingBagSummary)($6e24cb752a769415$var$PosterSize, $6e24cb752a769415$var$PrintType, $6e24cb752a769415$var$PosterFrame, $6e24cb752a769415$var$AcrylBlock, $6e24cb752a769415$var$t);
    $6KOho(".js-shipping-date").html((0, $47G0t.getShippingDate)({
        t: $6e24cb752a769415$var$t,
        formatDate: $6e24cb752a769415$var$formatDate
    }));
    $6e24cb752a769415$var$createPosterPreview();
}
function $6e24cb752a769415$var$getProductVariation() {
    const variationKey = $6e24cb752a769415$var$PrintType === "paper" ? `${$6e24cb752a769415$var$PosterSize}-${$6e24cb752a769415$var$PosterFrame}` : $6e24cb752a769415$var$PosterSize;
    const configuredProduct = (0, $gtTze.resolveCatalogProduct)($6e24cb752a769415$var$marketContext.catalog, "dictionary", $6e24cb752a769415$var$PrintType, variationKey);
    if (configuredProduct) return {
        id: configuredProduct.id,
        variation_id: configuredProduct.variationId
    };
    return {
        id: null,
        variation_id: null
    };
}
// Adding poster to cart
$6KOho(".js-save-poster").on("click", async function() {
    $6e24cb752a769415$var$saveDesign();
    let ProductID = $6e24cb752a769415$var$getProductVariation();
    $6KOho(this).html(`${$6e24cb752a769415$var$t("actions.savingDesign")} <span class="spinner-border spinner-border-sm ms-2" aria-hidden="true"></span>`).prop("disabled", true);
    let thumbnailUrl;
    try {
        thumbnailUrl = await (0, $8UUYp.uploadProductScreenshot)($6e24cb752a769415$var$PosterPreviewImage, $6e24cb752a769415$var$BuilderName);
    } catch (error) {
        console.error("Product screenshot kon niet worden opgeslagen", error);
        $6KOho(this).html($6e24cb752a769415$var$t("actions.addToCart")).prop("disabled", false);
        $6KOho(".js-notifications").append(`<div class="js-error alert alert-danger text-center p-2">${$6e24cb752a769415$var$t("sportsmap.errors.saveFailed")}</div>`);
        return;
    }
    let payload = {
        "add-builder-item-to-cart": true,
        edit_url: (0, $28FSP.getBuilderUrl)($6e24cb752a769415$var$marketContext, "woordenboek-poster", "/?preview"),
        thumbnail: thumbnailUrl,
        product_id: ProductID.id,
        ...$6e24cb752a769415$var$PrintType !== "tegel" && {
            variation_id: ProductID.variation_id
        },
        poster: {
            printType: $6e24cb752a769415$var$PrintType,
            size: $6e24cb752a769415$var$PosterSize,
            giftwrap: $6e24cb752a769415$var$PosterGiftwrapSelect.val(),
            giftcardText: $6e24cb752a769415$var$GiftCardText,
            wordLabel: $6e24cb752a769415$var$sanitizePosterInput(localStorage.getItem("WordLabel")),
            pronounceLabel: $6e24cb752a769415$var$sanitizePosterInput(localStorage.getItem("PronounceLabel")),
            wordTypeLabel: $6e24cb752a769415$var$sanitizePosterInput(localStorage.getItem("WordTypeLabel")),
            descriptionLabel: $6e24cb752a769415$var$sanitizePosterInput(localStorage.getItem("DescriptionLabel")),
            main: $6e24cb752a769415$var$sanitizePosterInput(localStorage.getItem("WordLabel")),
            ...[
                "aluminium"
            ].includes($6e24cb752a769415$var$PrintType) && {
                aluminiumColor: localStorage.getItem("aluminiumColor")
            },
            ...[
                "aluminium",
                "acryl",
                "tegel"
            ].includes($6e24cb752a769415$var$PrintType) && {
                acrylBlock: localStorage.getItem("acrylBlock")
            },
            ...[
                "paper"
            ].includes($6e24cb752a769415$var$PrintType) && {
                frame: $6e24cb752a769415$var$PosterFrame
            }
        },
        pdf: {
            type: "woordenboek",
            print: $6e24cb752a769415$var$PrintType === "paper" && $6e24cb752a769415$var$PosterFrame !== "no-frame" ? "framed-poster" : $6e24cb752a769415$var$PrintType
        }
    };
    // console.log("Payload: ", payload);
    let action = "add-to-cart";
    const endpoint = $6e24cb752a769415$var$apiBase + "/wp-json/wallable/v1/" + action;
    let didRetryAsForm = false;
    const runAjax = (useFormEncoding = false)=>{
        return $6KOho.ajax({
            url: endpoint,
            type: "POST",
            timeout: 20000,
            ...useFormEncoding ? {
                data: {
                    payload: JSON.stringify(payload)
                }
            } : {
                contentType: "application/json",
                data: JSON.stringify(payload)
            },
            error: (jqXHR, textStatus, errorThrown)=>{
                if (!useFormEncoding && !didRetryAsForm && jqXHR?.status === 0) {
                    didRetryAsForm = true;
                    return runAjax(true);
                }
                console.error(jqXHR, textStatus, errorThrown);
                setTimeout(()=>{
                    if (!$6KOho(".js-notifications").find(".js-error").length) $6KOho(".js-notifications").append(`<div class="js-error alert alert-danger text-center p-2">${$6e24cb752a769415$var$t("errors.generic")}</div>`);
                    $6e24cb752a769415$var$debugReporter.show({
                        meta: {
                            action: action,
                            didRetryAsForm: didRetryAsForm
                        },
                        request: {
                            url: endpoint,
                            method: "POST",
                            mode: useFormEncoding ? "form" : "json",
                            origin: window.location.origin,
                            woocommerceUrl: $6e24cb752a769415$var$woocommerceUrl,
                            online: navigator.onLine,
                            visibilityState: document.visibilityState
                        },
                        response: {
                            status: jqXHR?.status,
                            statusText: jqXHR?.statusText || textStatus,
                            thrownError: errorThrown ? String(errorThrown) : null,
                            responseText: (jqXHR?.responseText || "").slice(0, 4000)
                        }
                    });
                    $6KOho(this).html($6e24cb752a769415$var$t("actions.addToCart")).prop("disabled", false);
                }, 500);
            },
            success: ()=>{
                if (action === "add-to-cart") {
                    $6KOho(this).html($6e24cb752a769415$var$t("actions.addToCart")).prop("disabled", false);
                    window.location = $6e24cb752a769415$var$woocommerceUrl + "/cart/";
                } else {
                    if (!$6KOho(".js-notifications").find(".js-error").length) $6KOho(".js-notifications").append(`<div class="js-success alert alert-success text-center p-2">&#x2713; ${$6e24cb752a769415$var$t("actions.posterAdded")}</div>`);
                    $6KOho(this).html($6e24cb752a769415$var$t("actions.addToCart")).prop("disabled", false);
                }
            }
        });
    };
    runAjax(false);
});
// Tooltips
if (!$6e24cb752a769415$var$isPrintApp()) {
    var $6e24cb752a769415$var$tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    var $6e24cb752a769415$var$tooltipList = $6e24cb752a769415$var$tooltipTriggerList.map(function(tooltipTriggerEl) {
        return new $k4QTz.Tooltip(tooltipTriggerEl);
    });
}


//# sourceMappingURL=woordenboek-poster.e51d3a04.js.map
